export default __webpack_public_path__ + "static/media/PETS.fa8827e3.png";